import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import Button from "../../Component/Common/Button";
import Pagination from "../../Component/Common/Pagination";
import Table from "../../Component/Common/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getVideoApi,
  deleteVideo,
  isLiveToogle,
  getOrgVideo,
  toggleOrgVideoPublish,
  deleteOrgVideo,
} from "../../store/video/video.action";
import { warning } from "../../util/Alert";
import { covertURl } from "../../util/AwsFunction";
import UserImage from "../../assets/images/no-profile.jpg";
import $ from "jquery";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../../Component/Common/ToggleSwitch";
import DataActions from "../../Component/Common/DataActions";

function ManageVideo(props) {
  const { startDate, endDate } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [actionPagination, setActionPagination] = useState("");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [data, setData] = useState([]);
  const [showURLs, setShowURLs] = useState([]);
  const [showVideoURLs, setShowVideoURLs] = useState([]);
  const [expandedTitle, setExpandedTitle] = useState({});
  const toggleReview = (index) => {
    setExpandedTitle((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const { profile, tokenData } = useSelector((state) => state.loggedUser);
  const { videoData, totalVideo } = useSelector((state) => state.video);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  $(document).ready(function () {
    $("img").bind("error", function () {
      // Set the default image
      $(this).attr("src", UserImage);
    });
  });

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };
  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;

    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id),
      );
    }
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            if (res.isConfirmed) {
              if (tokenData.isOrg) {
                dispatch(deleteOrgVideo(selectCheckDataGetId));
              } else {
                props.deleteVideo(selectCheckDataGetId);
              }
              setSelectAllChecked(false);
            }
          }
        })
        .catch((err) => console.log(err));
    }

    setActionPagination("");
    setSelectCheckData([]);
    setSelectAllChecked(false);
  };

  const handleDeleteVideo = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            if (tokenData.isOrg) {
              dispatch(deleteOrgVideo([id]));
            } else {
              props.deleteVideo(id);
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const handleIsLiveToggle = (row) => {
    const id = row?._id;
    const data = row?.isVideoPublished === false ? true : false;
    if (tokenData.isOrg) {
      dispatch(toggleOrgVideoPublish(id, "video", data));
    } else {
      dispatch(isLiveToogle(id, "video", data));
    }
  };

  useEffect(() => {
    if (data) {
      fetchData();
      fetchVideoData();
    }
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data?.map(async (item) => {
        const fileNameWithExtension = item?.image?.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };

  const fetchVideoData = async () => {
    if (!data || data?.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data &&
        data?.map(async (item) => {
          const fileNameWithExtension = item?.videoUrl?.split("/").pop();
          const { imageURL } = await covertURl(
            "Videos/" + fileNameWithExtension,
          );

          return imageURL;
        }),
    );
    setShowVideoURLs(urls);
  };

  const handleEdit = (row, type) => {
    dispatch({
      type: OPEN_DIALOGUE,
      payload: {
        type: type,
        data: row,
      },
    });

    let dialogueData_ = {
      dialogue: true,
      type: type,
      dialogueData: row,
    };
    sessionStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
  };

  const videoMapData = [
    {
      Header: (
        <input
          type="checkbox"
          checked={selectAllChecked}
          onChange={handleSelectAll}
        />
      ),
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id,
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "USER ID",
      body: "uniqueId",
      Cell: ({ row }) => <span className="">{row?.uniqueId}</span>,
    },
    {
      Header: "VIDEO ID",
      body: "uniqueVideoId",
      Cell: ({ row }) => <span className="">{row?.uniqueVideoId}</span>,
    },
    {
      Header: "TITTLE",
      Cell: ({ row, index }) => {
        const isExpanded = expandedTitle[index];
        const titleText = row?.title;
        const previewText = titleText?.substring(0, 30);

        return (
          <span
            className="text-capitalize fw-bold d-block mx-auto"
            style={{ maxWidth: "200px" }}
          >
            {isExpanded ? titleText : previewText}
            {titleText.length > 30 && (
              <span
                onClick={() => toggleReview(index)}
                className="read-more text-danger bg-none ps-2"
              >
                {isExpanded ? "Read less" : "Read more..."}
              </span>
            )}
          </span>
        );
      },
    },
    {
      Header: "Video",
      body: "video",
      Cell: ({ row, index }) => (
        <div>
          <video
            controls
            width="150px"
            height="100px"
            style={{ borderRadius: "10px" }}
            src={showVideoURLs[index]}
          />
        </div>
      ),
    },

    {
      Header: "USER",
      body: "addedBy",
      Cell: ({ row, index }) => (
        <div
          className="d-flex align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() =>
            tokenData.isOrg
              ? null
              : navigate("/admin/userProfile", { state: { id: row?.userId } })
          }
        >
          <img src={showURLs[index]} width="40px" height="40px" />
          <span className="text-capitalize    text-nowrap">
            {row?.nickName}
          </span>
        </div>
      ),
    },

    {
      Header: "Language",
      Cell: ({ row, index }) => (
        <div className="d-flex justify-content-center align-items-center">
          {row?.language}
        </div>
      ),
    },

    ...(!tokenData?.isOrg ||
    profile?.role === "org_admin" ||
    profile?.role === "org_owner"
      ? [
          {
            Header: "LIVE TOGGLE",
            body: "isActive",
            Cell: ({ row }) => (
              <ToggleSwitch
                checked={row?.isVideoPublished}
                onChange={() => handleIsLiveToggle(row)}
              />
            ),
          },
        ]
      : []),
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) =>
        !tokenData.isOrg ||
        (tokenData.isOrg &&
          (profile?.role === "org_admin" ||
            profile?.role === "org_owner" ||
            (profile?.role === "org_creator" &&
              profile.userId === row?.userId))) ? (
          <div className="action-button">
            <Button
              className="icon-btn"
              startIcon={<EditIcon />}
              onClick={() => handleEdit(row, "editVideo")}
            />
            <Button
              className="icon-btn"
              startIcon={<TrashIcon />}
              onClick={() => handleDeleteVideo(row)}
            />
          </div>
        ) : null,
    },
  ];

  useEffect(() => {
    console.log("videoData", videoData);
    setData(videoData);
  }, [videoData]);

  useEffect(() => {
    if (tokenData?._id) {
      if (tokenData.isOrg) {
        dispatch(
          getOrgVideo({
            videoType: 1,
            page,
            limit: size,
            startDate,
            endDate,
            searchText: debounceSearchText,
          }),
        );
      } else {
        dispatch(
          getVideoApi({
            videoType: 1,
            page,
            limit: size,
            startDate,
            endDate,
            searchText: debounceSearchText,
          }),
        );
      }
    }
  }, [dispatch, startDate, endDate, page, size, debounceSearchText, tokenData]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start mb-3">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "4px",
                marginTop: "5px",
              }}
            >
              Manage & Edit Videos
            </h5>
          </div>

          <DataActions
            searchInputProps={{
              placeholder: "Search for ID, Title, User, Channel",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
            showActionOptions={true}
            dropdownProps={{
              value: actionPagination,
              options: [
                {
                  label: "Delete",
                  value: "delete",
                },
              ],
              onChange: (value) => setActionPagination(value),
            }}
            actionButtonProps={{
              disabled: !actionPagination && !selectCheckData.length,
              onClick: paginationSubmitButton,
            }}
          />
        </div>

        <Table
          data={data}
          mapData={videoMapData}
          noDataMessage="No Video Found!"
        />

        <div className="mt-3">
          <Pagination
            totalItem={totalVideo}
            activePage={page}
            pageSize={size}
            onActivePageChange={handlePageChange}
            onPageSizeChange={handleRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
}
export default connect(null, {
  getVideoApi,
  deleteVideo,
})(ManageVideo);
